import React from 'react';
import { Box, Flex, Text } from '@opendoor/bricks/core';
import { Illustration, IllustrationProps } from '@opendoor/cinderblocks/platform/Illustration';
import { InternalLink, InternalLinkProps } from 'platform/react-router';

interface SwitchVaCardProps {
  /** Description to show above the link */
  description: string;
  /** Illustration to display in this card */
  illustrationName: IllustrationProps['illustrationName'];
}

/**
 * Card for the SSVA Target Experiment for allowing users to switch their VA experience
 * component-test-check-ignore
 */
export const SwitchVaCard: React.FC<SwitchVaCardProps & InternalLinkProps> = ({
  description,
  illustrationName,
  ...linkProps
}) => (
  <Flex
    borderWidth="2px"
    borderColor="neutrals20"
    borderStyle="solid"
    p={[6, 6, 8]}
    borderRadius="semiRounded"
    flexDir={['row', null, 'column']}
    gridGap={6}
  >
    <Illustration illustrationName={illustrationName} type="spot" width={['48px', null, '80px']} />
    <Box>
      <Text
        fontWeight={['semibold', null, 'bold']}
        fontSize={['s0', null, 's2']}
        lineHeight={['s0', null, 's2']}
        mb={[0, 0, 3]}
      >
        {description}
      </Text>
      <InternalLink fontSize={['s0', null, 's1']} fontWeight="semibold" {...linkProps} />
    </Box>
  </Flex>
);
